/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('adr', [
  'getAdr',
  'applyAdr',
  'unapplyAdr',
  'getNodeAdr',
  'getNodeAdrLogs',
]);

function getAdr() {
  return createAPIAction(
    types.getAdr,
    {
      endpoint: '/features/adr',
    })();
}

function applyAdr() {
  return createAPIAction(
    types.applyAdr,
    {
      endpoint: '/features/adr/apply',
      method: 'POST',
    },
  )();
}

function unapplyAdr() {
  return createAPIAction(
    types.unapplyAdr,
    {
      endpoint: '/features/adr/unapply',
      method: 'POST',
    },
  )();
}

function getNodeAdr(id) {
  return createAPIAction(
    types.getNodeAdr,
    {
      endpoint: `/lora/nodes/${id}/adr`,
      method: 'GET',
    },
  )();
}

function getNodeAdrLogs(id, args) {
  return createAPIAction(
    types.getNodeAdrLogs,
    {
      endpoint: `/lora/nodes/${id}/adr/logs`,
      method: 'GET',
      query: args,
    },
  )();
}

export default {
  getAdr,
  applyAdr,
  unapplyAdr,
  getNodeAdr,
  getNodeAdrLogs,
};




// WEBPACK FOOTER //
// ./src/redux/actions/adr.js